
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vanlife",
      function () {
        return require("private-next-pages/vanlife/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vanlife"])
      });
    }
  